export const GradeEnum = [
  { label: '未评', value: 0 },
  { label: '国家 A 级景区', value: 1 },
  { label: '国家 2A 级景区', value: 2 },
  { label: '国家 3A 级景区', value: 3 },
  { label: '国家 4A 级景区', value: 4 },
  { label: '国家 5A 级景区', value: 5 },
];

export const DocumentTypeEnum = [
  { label: '身份证', value: 'ID_CARD' },
];

//有效期类型，可用值:FIXED,LONG_TERM
export const ExpirationDateTypeEnum = [
  { label: '长期', value: 'LONG_TERM' },
  { label: '固定', value: 'FIXED' },
];
